import "../../assets/css/popupShop.css";
import React, { useEffect, useState } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { WooCommerceController } from "../../controllers/wooCommerceController";
import { Loading } from "../../components/loading";
import { CurrencyLabel } from "../../components/currencyLabel";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PopupShopProduct } from "./popupShopProduct";

export const PopupShop = ({ isShowSectionTitle = true }) => {
  const navigate = useNavigate();
  const [productsByCategory, setProductsByCategory] = useState([]);
  const [currency, setCurrency] = useState("&#82;&#77;");
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState([]);
  const [colors] = useState(() => JSON.parse(localStorage.getItem("colors")));
  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});

  const getAll = async () => {
    const categorySlug = "dokokoko-cafe";
    try {
      const currencyType = await WooCommerceController.getCurrentCurrency();
      setCurrency(currencyType?.symbol);
      const categoryId = (
        await WooCommerceController.getCategoriesViaSlug(categorySlug)
      )[0]?.id;
      const subcategories =
        await WooCommerceController.getSubcategoriesViaCategoryId(categoryId);
      if (subcategories.length < 1) {
        setLoading(false);
        return;
      }
      const groupedProducts = [];
      for (const subcategory of subcategories) {
        const fetchedProducts =
          await WooCommerceController.getProductsViaCategoryId(subcategory.id);
        groupedProducts.push({
          subcategoryId: subcategory.id,
          subcategoryName: subcategory.name,
          subcategoryImage: subcategory.image,
          products: fetchedProducts,
        });
      }
      setProductsByCategory(groupedProducts);
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Get cart from localStorage when the component loads
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(savedCart);

    getAll();
  }, [colors]);

  const addToCart = (product) => {
    const existingProductIndex = cart.findIndex(
      (item) => item.id === product.id
    );
    let updatedCart = [];

    if (existingProductIndex !== -1) {
      // If the product already exists in the cart, update quantity
      updatedCart = [...cart];
      updatedCart[existingProductIndex].quantity += 1;
    } else {
      // If it's a new product, add it with quantity 1
      updatedCart = [...cart, { ...product, quantity: 1 }];
    }

    setCart(updatedCart);
    // Store updated cart in localStorage
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    toast.success(`${product.name} added successfully.`);
  };

  const removeFromCart = (productSku) => {
    const updatedCart = cart.filter((item) => item.id !== productSku);
    setCart(updatedCart);
    // Store updated cart in localStorage
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const showCart = () => {
    console.log("Cart:", cart);
  };

  const handleProduct = (product) => {
    setSelectedProduct(product);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <section
      id="popupShop"
      style={{
        "--primary-color": colors.primaryColor || "#ffffff",
        "--secondary-color": colors.secondaryColor || "#000000",
        "--tertiary-color": colors.tertiaryColor || "#ffffff",
      }}
    >
      <div className="button-container">
        <Button onClick={() => navigate("/")}>Back To Home Page</Button>
        {cart.length > 0 ? (
          <Button className="arrow-button" onClick={showCart}>
            <span className="arrow">{">"}</span>SHOW CART
            <span className="arrow">{"<"}</span>
          </Button>
        ) : (
          <Button
            className="arrow-button arrow-button-disabled"
            onClick={() => {}}
          >
            <span className="arrow">{">"}</span>SHOW CART
            <span className="arrow">{"<"}</span>
          </Button>
        )}
      </div>

      <div className="popupShop-container">
        {isShowSectionTitle && (
          <div>
            <h3>POPUP SHOP</h3>
            <hr />
          </div>
        )}
        {productsByCategory.map((category, index) => (
          <div key={index}>
            <h4>{category.subcategoryName}</h4>
            <div>
              <ImageList
                variant="masonry"
                cols={3}
                gap={8}
                className="popupShop-list"
              >
                {category.products.map((product) => (
                  <ImageListItem
                    key={product.id}
                    className="cursor-pointer"
                    onClick={() => handleProduct(product)}
                  >
                    <img
                      src={product.images[0]?.src}
                      alt={product.images[0]?.alt || product.name}
                      loading="lazy"
                    />
                    <div>
                      <div className="variant-preview">
                        {product.images.slice(1).map((image, index) => (
                          <img
                            key={index}
                            className="series-preview-image"
                            src={image?.src}
                            alt={image?.alt || product.name}
                            loading="lazy"
                          />
                        ))}
                      </div>
                      <ImageListItemBar
                        className="image-list-item-bar"
                        title={product.name}
                        subtitle={product.description}
                        actionIcon={
                          <div className="wrapper">
                            <div className="currency-label">
                              <CurrencyLabel currency={currency} />
                            </div>
                            <div className="price-label">{product.price}</div>
                            <Tooltip title="Add To Cart">
                              <IconButton onClick={() => addToCart(product)}>
                                <AddShoppingCartIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        }
                      />
                    </div>
                  </ImageListItem>
                ))}
              </ImageList>
            </div>
            <hr />
          </div>
        ))}
        <PopupShopProduct
          open={open}
          handleClose={handleClose}
          currency={currency}
          selectedProduct={selectedProduct}
          onAddToCart={addToCart}
        />
      </div>
    </section>
  );
};
